// src/components/ProductBlock.jsx
import { useState } from "react";
import { Button } from 'react-bootstrap';


const ProductBlock = ({ product }) => {
  const [activeImage, setActiveImage] = useState(product.images[0]);

  const handleHover = (index) => {
    if (product.images[index]) {
      setActiveImage(product.images[index]);
    }
  };

  const handleLeave = () => {
    setActiveImage(product.images[0]);
  };

  return (
    <div className="bp-block__item">
      <div className="bp-block__badges">
        {product.badges.map((badge, i) => (
          <div key={i} className="bp-block__badge">{badge}</div>
        ))}
      </div>

      <a href={product.link} className="bp-block__img-block">
        <img src={activeImage} alt="" className="bp-block__img" />
      </a>

      <div className="bp-block__colors">
        {product.colors.map((color, i) => (
          <div
            key={i}
            className="bp-block__color"
            style={{ backgroundColor: color }}
            onMouseEnter={() => handleHover(i)}
            onMouseLeave={handleLeave}
          />
        ))}
      </div>

      <a href={product.link} className="bp-block__item-name" >
        {product.name}
      </a>

      <div className="bp-block__char">
        {product.characteristic}
      </div>
          <div className="bp-block__char d-flex ">
            <Button
              variant="outline-light"
              className="rounded-4 px-4 w-100"
              onClick={() => console.log("Купить", product.name)}
            >
              Купить
            </Button>
          </div>
    </div>

  );
};

export default ProductBlock;
